import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import { StyledCheckboxInput } from "../../../../common/form";
import { MessageBox } from "../../../../common/";

class RenderCoverageList extends React.Component {
  componentWillMount() {
    this.props.fields.removeAll();

    this.props.withdrawalClientCoverages.map((coverage) => {
      this.props.fields.push({ ...coverage });
    });
  }

  componentWillUpdate(nextProps) {
    const same = this.props.withdrawalClientCoverages.every((coverage) =>
      nextProps.withdrawalClientCoverages.some(
        (newCoverage) =>
          newCoverage.clientCoverageId == coverage.clientCoverageId
      )
    );
    if (!same) {
      this.props.fields.removeAll();

      nextProps.withdrawalClientCoverages.map((coverage) => {
        this.props.fields.push({ ...coverage });
      });
    }
  }

  componentWillUnmount() {
    this.props.fields.removeAll();
  }

  render() {
    const { touched, dirty, error } = this.props.meta;
    const fields = this.props.fields.map((clientCoverage, index) => {
      const fieldClasses = classNames({
        "client-coverage": true,
        disabled: this.props.withdrawalClientCoverages[index].disabled,
      });
      return (
        <Field
          key={index}
          groupClassName={fieldClasses}
          id={`${clientCoverage}.checked`}
          name={`${clientCoverage}.checked`}
          component={StyledCheckboxInput}
          type="checkbox"
          checkbox={{
            value: this.props.withdrawalClientCoverages[index].clientCoverageId,
          }}
          disabled={this.props.withdrawalClientCoverages[index].disabled}
          label={this.props.withdrawalClientCoverages[index].name}
          props={{ onChange: this.props.onChange }}
        />
      );
    });

    return (
      <div>
        <div className="field-array client-coverage-list">{fields}</div>
        {(touched || dirty) && error && (
          <MessageBox className="alert-danger simple">
            <FormattedMessage id={this.props.meta.error.messageKey} />
          </MessageBox>
        )}
      </div>
    );
  }
}

RenderCoverageList.propTypes = {
  withdrawalClientCoverages: PropTypes.array,
  fields: PropTypes.object,
  meta: PropTypes.object,
  onChange: PropTypes.func,
};

export default RenderCoverageList;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/RenderCoverageList.js